import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource, ResourcesListingFilter } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  resources: Identifiable<Resource>[];
  filter: ResourcesListingFilter;
  totalPages: number;
  projectUuid: string | null;
  isDirty: boolean;
  retrieveFilterResources(
    request: Boundaries["retrieveFilterResources"]["request"],
  ): void;
}

function useRetrieveFilterResources(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveFilterResourcesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveFilterResourcesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveFilterResourcesRequestFailure,
    ),
    resources: useSelector(selector.getFilterResources),
    filter: useSelector(selector.getFilterResourcesFilter),
    totalPages: useSelector(selector.getFilterResourcesTotalPages),
    projectUuid: useSelector(selector.getFilterResourcesProjectUuid),
    isDirty: useSelector(selector.areFilterResourcesDirty),
    retrieveFilterResources: core.retrieveFilterResources,
  };
}

export { useRetrieveFilterResources };
